import createApiService from "@lib/create-api-service";
import { API_ROUTES } from "@utils/constants";

import validateAddressesResponse, { TAddressesResponse } from "../models/addresses";
import type { TAddressBookEntry } from "../types";
import mapAddressBookResponse from "../utils/mapAddressBookResponse";

type TLoadAddressesParams = {
  search: string;
  countryCode: string;
  type: "locker" | "address";
  onError?: (message?: string) => void;
};

const getAddresses = createApiService<TAddressesResponse>({ method: "GET", url: API_ROUTES.ADDRESS_BOOK });

const loadAddresses = async ({
  search,
  countryCode,
  type,
  onError,
}: TLoadAddressesParams): Promise<TAddressBookEntry[]> => {
  try {
    const params = { countryCode, type, ...(search && { search }) };
    const response = await getAddresses({ params });
    if (!response.isSuccess) {
      onError?.(response.errorMessage);
      return [];
    }

    const addressBookResponse = validateAddressesResponse(response.data || []);
    return mapAddressBookResponse(addressBookResponse);
  } catch (err) {
    console.error("Failed to load addresses from address book", err);
    onError?.();
    return [];
  }
};
export default loadAddresses;
